import BarChart from '@cloudscape-design/components/bar-chart';
import { Box } from '@cloudscape-design/components';
import { colours } from "./colours";
import { Formatter } from "../../format";
import { useTranslation } from 'react-i18next';

export const SpeakerTimeChart = ({ data = [], chartHeight = 237 }) => {
  const { t } = useTranslation();

  if (!data || data.length === 0) {
    return (
      <Box textAlign="center" padding="l">
        <b>{t("charts.noData")}</b>
      </Box>
    );
  }

  const totalTime = Math.ceil(data.reduce((prev, curr) => curr.value + prev, 0));

  // Transformar datos al formato que espera Cloudscape BarChart
  // Cada speaker es una serie de barras apiladas
  const speakerLabel = t("speaker") || "Speaker";
  
  const series = data.map(entry => ({
    type: 'bar',
    title: entry.label,
    data: [{
      x: speakerLabel, // Categoría en el eje X
      y: entry.value / totalTime // Porcentaje (0 a 1)
    }],
    color: colours[entry.channel],
    valueFormatter: (value) => Formatter.Percentage(value)
  }));

  return (
    <BarChart
      series={series}
      height={chartHeight}
      xScaleType="categorical"
      yScaleType="linear"
      xDomain={[speakerLabel]}
      yDomain={[0, 1]}
      xTitle={"Participantes"}
      yTitle={t("charts.percentage") || "Porcentaje"}
      stackedBars={true}
      hideFilter={true}
      emphasizeBaselineAxis={true}
      ariaLabel={t("charts.speakerTimeChartAriaLabel") || "Gráfico de tiempo conversado por participante"}
      ariaDescription={t("charts.speakerTimeChartDescription") || "Muestra el porcentaje de tiempo que habló cada participante"}
      i18nStrings={{
        legendAriaLabel: t("charts.legendAriaLabel") || "Leyenda",
        chartAriaRoleDescription: t("charts.chartAriaRoleDescription") || "gráfico de barras",
        xAxisAriaRoleDescription: t("charts.xAxisAriaRoleDescription") || "eje X",
        yAxisAriaRoleDescription: t("charts.yAxisAriaRoleDescription") || "eje Y",
        xTickFormatter: () => "", // Ocultar labels del eje X
        yTickFormatter: (value) => Formatter.Percentage(value)
      }}
    />
  );
};
